import { useQuery } from "react-query"
import { getLeadPendingsStatisticCardsData } from "api/Pendings";


export const useLeadsPendingStatisticCardsData = () => {
    return useQuery<Array<any> | any>(
      ['leadPending'],
        () => getLeadPendingsStatisticCardsData(),
        {
            onError(error: any) {
                console.error(error)
            }
        }
    )
}